import concat from "lodash/fp/concat";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import map from "lodash/fp/map";
import uniq from "lodash/fp/uniq";
import uniqBy from "lodash/fp/uniqBy";

import selectSelectedProduct from "./selectSelectedProduct";
import { getFlatFields } from "utils";

const selectFieldsForQueryParams = (state) => {
  const customisationsVisited = get(["app", "customisationsVisited"])(state);
  return flow(
    selectSelectedProduct,
    getOr([], "customisations"),
    filter(({ id }) => customisationsVisited.includes(id)),
    getFlatFields,
    uniqBy("name"),
    map(get("name")),

    concat([
      "recipeID",

      // for goalie gear
      "customise-pads",
      "customise-glove",
      "customise-blocker",
      "full-right-hand",
      "t-trap-reinforced",
    ]),

    uniq
  )(state);
};

export default selectFieldsForQueryParams;
